import React, { Fragment, useMemo } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import SanitizedHtml from 'components/SanitizedHtml'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'

const Styles = styled.div`
  h1,
  h2 {
    margin-bottom: 0.5rem;
  }

  h3,
  h4,
  h5 {
    margin-top: 3rem;
    margin-bottom: 0;
  }
`

const Deiliskipulag = ({ data = null }) => {
  const { afangi } = useParams()
  const { deiliskipulag } = data?.find((item) => item.slug === afangi)
  const { body } = deiliskipulag ?? {}

  const columns = useMemo(() => {
    return body ? body.split('<hr />') : []
  }, [body])

  return columns.length > 0 ? (
    <Styles>
      <Container fluid className="py-5">
        <Row>
          {columns.map((body, idx) => (
            <Fragment key={idx}>
              <Col className="pr-md-7" md={6}>
                <SanitizedHtml html={body} />
              </Col>
              {idx === 0 ? <div className="w-100" /> : null}
            </Fragment>
          ))}
        </Row>
      </Container>
    </Styles>
  ) : null
}

export default Deiliskipulag
